import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 16,
	viewBox: "0 0 19 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.28304 6.93972C1.00214 7.22097 0.84436 7.60222 0.84436 7.99972C0.84436 8.39722 1.00214 8.77847 1.28304 9.05972L6.93904 14.7187C7.22044 15.0001 7.60209 15.1582 8.00004 15.1582C8.39799 15.1582 8.77965 15.0001 9.06104 14.7187C9.34244 14.4373 9.50052 14.0557 9.50052 13.6577C9.50052 13.2598 9.34244 12.8781 9.06104 12.5967L5.96504 9.49972L17.5 9.49972C17.8979 9.49972 18.2794 9.34169 18.5607 9.06038C18.842 8.77908 19 8.39755 19 7.99972C19 7.6019 18.842 7.22037 18.5607 6.93906C18.2794 6.65776 17.8979 6.49972 17.5 6.49972L5.96504 6.49972L9.06104 3.40372C9.20037 3.26439 9.3109 3.09898 9.3863 2.91693C9.46171 2.73489 9.50052 2.53977 9.50052 2.34272C9.50052 2.14568 9.46171 1.95056 9.3863 1.76851C9.3109 1.58647 9.20037 1.42105 9.06104 1.28172C8.92171 1.14239 8.7563 1.03187 8.57425 0.95646C8.3922 0.881054 8.19709 0.842242 8.00004 0.842242C7.80299 0.842242 7.60788 0.881054 7.42583 0.95646C7.24378 1.03187 7.07837 1.14239 6.93904 1.28172L1.28304 6.93972Z",
		fill: "#3D3938"
	})]
});
const ForwardRef = forwardRef(SvgArrow);
export default ForwardRef;
